import { Environments, getEnvironmentFromHost } from '../api/endpoints';

export default class UrlHelper {
  static addQueryParam(url: string, params: { [key: string]: string }): string {
    if (!url) return url;

    let queryParams = [];
    const urlParts = url.split('?');
    let existingQueryParams = urlParts.length > 1 ? urlParts.pop() : undefined;
    if (existingQueryParams) {
      queryParams.push(existingQueryParams);
    }
    for (let p in params) {
      queryParams.push(encodeURIComponent(p) + '=' + encodeURIComponent(params[p]));
    }

    return urlParts[0] + '?' + queryParams.join('&');
  }

  static parseUrl(url: string): ParsedUrl {
    const parsedURL = url.trim().split('?');
    const redirectURL = parsedURL[0];
    let queryParams: QueryParam[] = [];

    if (parsedURL.length === 1 || (parsedURL.length === 2 && parsedURL[1] === '')) {
      queryParams = [];
    } else {
      queryParams = parsedURL[1].split('&').map((queryParam: string) => {
        const parsedQueryParam = queryParam.split('=');
        const key = parsedQueryParam[0];
        const value = parsedQueryParam.length > 1 ? parsedQueryParam[1] : '';
        return { key, value };
      });
    }

    return {
      url: redirectURL,
      queryParams,
    };
  }

  static createAccountOnClick = () => {
    const env = getEnvironmentFromHost(window.location.hostname);
    env === Environments.prod
      ? window.open(`https://app.ace.aaa.com/enterprise/identity/#/register`)
      : window.open(`https://${window.location.hostname}/enterprise/identity/${env}/#/register`);
  };
}
interface QueryParam {
  key: string;
  value: string;
}

interface ParsedUrl {
  url: string;
  queryParams: QueryParam[];
}
